module.exports = __webpack_public_path__ + "static/media/qiToolkit.09c5c58c.pdf";